import React, { useState} from 'react';
import MenuCountryItem from './MenuCountryItem';
import PrematchContext from '../../../contexts/PrematchContext';
import { handleCanonicalUrl, isSeoSettingsNoFollow } from '../../../data/seo/seoUtils';
import { getConfiguration, getEncodedURI, iconSportCssClass } from '../../../data/utils';
import { SeoContext } from '../../../data/seo/SeoContextProvider';
import MainContext from '../../../contexts/MainContext';
import { useAbsolutePath } from '../../../data/seo/seoRouteUtils';

function MenuSportItem(props) {
    const mainContext = React.useContext(MainContext);
    const prematchContext = React.useContext(PrematchContext);
    const seoContext = React.useContext(SeoContext);
    const [isCollapsed, setIsCollapsed] = useState(true);

    function handleClick(url, e) {
        e.preventDefault();
        if (isCollapsed && (prematchContext.selectedTournaments.length === 0 || conf.iwh )) {
            prematchContext.openSelectionMenu(props.id);
        }
        setIsCollapsed(!isCollapsed);
        e.stopPropagation();
        if (isCollapsed) {
	    	if (!window.appConfig.SHOP_MODE) {
	    		handleHistory(url);        	
	        }
        }
    }

    function handleClickHref(url,e) {
        e.preventDefault();
    }

    function handleHistory(url) {
        if (window.history) {
            seoContext.refreshPathname(sportPath,mainContext.currentSection.current);
            handleCanonicalUrl(url);
            if(mainContext.historyNavigationEnabled){
                if(window.location.pathname != url) {
                    window.history.pushState(window.history.state, null, url);
                }
            }else{
                window.history.replaceState(window.history.state, null, url);
            }
        }
    }

    const sportPath = `${props.urlPath}${props.urlPathSuffix}`;
    const absoluteSportPath = useAbsolutePath(sportPath, null, props.urlPathSeo);  
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);
    const conf = getConfiguration()

    const icoSport = iconSportCssClass(props.id, props.iconClass);
    return (
        <div className={"card elemento-competizioni-widget sport-color-" + props.id}>
            <div className={"titolo-accordion maiuscolo bianco d-flex d-centro-v pointer toggle-nascondi-live tog-menu " + (isCollapsed ? "collapsed" : "")} id={`sport-${props.id}`} data-parent="#accordionLaterale" href={`#menu-sport-${props.id}`} onClick={handleClick.bind(this, absoluteSportPath)}>
                <a href={getEncodedURI(absoluteSportPath)} className="d-flex d-centro-v maiuscolo grassetto" onClick={handleClickHref.bind(this, absoluteSportPath)} {...(noFollow ? {rel: 'nofollow'} : {})}>
                    <div className={`icona-sport img-fluid margine-dx-mezzo ico-sport ${icoSport}`}></div>
                    {props.descrizione}
                </a>
                {props.isLive &&
                    <span className="live-badge"></span>
                }
                <span> 
                {conf.iwh ? `(${props.eventsCountByFilter?.[prematchContext.temporalFilter] ?? props.eventsCount})` : (props.eventsCountByFilter?.[prematchContext.currentFilter] ?? props.eventsCount)}
               </span>
            </div>
            <div id={`menu-sport-${props.id}`} className={"competzioni-sub margine-su-mezzo collapse " + (!isCollapsed ? "show" : "")} role="tabpanel" aria-labelledby={`sport-${props.id}`}>
                {props.categories.map( category =>
                    <MenuCountryItem key={category.id} {...category} sportId={category.sportRef} menuLiveTogglers={props.menuLiveTogglers} />
                )}
            </div>
        </div>
    );
}
    
export default MenuSportItem;